module.exports = __webpack_public_path__ + "img/frame (257).a1848971.jpg";